var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoungeInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5C9.38071 14.5 10.5 13.3807 10.5 12C10.5 10.6193 9.38071 9.5 8 9.5C6.61929 9.5 5.5 10.6193 5.5 12C5.5 13.3807 6.61929 14.5 8 14.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.705 7.5H12.5C12.2348 7.5 11.9804 7.60536 11.7929 7.79289C11.6054 7.98043 11.5 8.23478 11.5 8.5V15.5H4.5V6.5H2.5V20.5H4.5V17.5H20.5V20.5H22.5V12.295C22.4987 11.0237 21.9931 9.80483 21.0941 8.90588C20.1952 8.00693 18.9763 7.50132 17.705 7.5ZM13.5 15.5V9.5H17.705C18.4459 9.50132 19.156 9.79622 19.6799 10.3201C20.2038 10.844 20.4987 11.5541 20.5 12.295V15.5H13.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoungeInactive);
export default __webpack_public_path__ + "static/media/lounge-inactive.442331720a39e8433705b83e6dfd01ea.svg";
export { ForwardRef as ReactComponent };